/* !
 * recipesFavorite.js v1.0.0
 * Copyright, Connecty Inc.
 */
((FUNCTIONS) => {
	const v = 'is-visible';
	const countNUM = 20;
	const FAVO_MAX = 50;
	let vueApp = document.querySelector('#vue-app');

	// localStorageから抽出
	let favoStorage = [];

	for (let i in localStorage) {
		if (i.indexOf('pokkasapporoFavoriteRecipeList-') !== -1) { favoStorage.push(i); }
	}
	if (favoStorage.length) {
		let recipeParams = '';
		favoStorage.forEach(ele => {
			recipeParams += `&p_recipe_id=${ele.replace(/pokkasapporoFavoriteRecipeList-/, '')}`;
		});
		recipeParams = recipeParams.slice(1);

		fetch(`/ajax/recipes/detail/data.json?${recipeParams}`).then(response => response.json()).then(data => {
			if (data.rt_bn_recipe_detail.length) {
				let recipeData = data.rt_bn_recipe_detail;
				recipeData.forEach(ele => {
					if (ele.cf_r_status) {
						ele.datetime = localStorage.getItem(`pokkasapporoRecentRecipeList-${ele._key}`);
					} else {
						localStorage.removeItem(`pokkasapporoFavoriteRecipeList-${ele._key}`);
					}
				});
				recipeData.sort((x, y) => {
					let xDate = x['datetime'];
					let yDate = y['datetime'];
					if (xDate > yDate) return -1;
					if (xDate < yDate) return 1;
					return 0;
				});
				if (recipeData.length > FAVO_MAX) {
					localStorage.removeItem(`pokkasapporoRecentRecipeList-${recipeData[FAVO_MAX]._key}`);
					recipeData.pop();
				}

				Vue.createApp({
					data() {
						return {
							recipeData: recipeData,
							dispItemSize: countNUM,
							num: 0,
							page: 0,
						}
					},
					methods: {
						showPrev() {
							if (this.isStartPage) return;
							vueApp.classList.remove(v);
							this.page--;
							setTimeout(() => {
								vueApp.classList.add(v);
								window.scrollTo({ top: 0, behavior: 'smooth' });
							}, 200);
						},
						showNext() {
							if (this.isEndPage) return;
							vueApp.classList.remove(v);
							this.page++;
							setTimeout(() => {
								vueApp.classList.add(v);
								window.scrollTo({ top: 0, behavior: 'smooth' });
							}, 200);
						},
						showPage(index) {
							vueApp.classList.remove(v);
							this.page = index;
							setTimeout(() => {
								vueApp.classList.add(v);
								window.scrollTo({ top: 0, behavior: 'smooth' });
							}, 200);
						}
					},
					computed: {
						filterItems() {
							let items = this.recipeData;

							let startPage = this.page * this.dispItemSize;
							items = items.slice(startPage, startPage + this.dispItemSize);

							return (items);
						},
						isStartPage() {
							return (this.page === 0);
						},
						isEndPage() {
							return ((this.page + 1) * this.dispItemSize >= this.num);
						},
						pageCount() {
							return Math.ceil(this.num / this.dispItemSize);
						}
					},
					mounted() {
						this.num = recipeData.length;
						vueApp.classList.add(v);
					}
				}).mount('#vue-app');
			}
		});
	} else {
		document.querySelector('.recipe-list').remove();
		vueApp.innerHTML = '<p class="ta_center">お気に入りレシピの登録はありません。</p>';
		vueApp.classList.add(v);
	}

})(window.FUNCTIONS);